function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function isInViewport(element) {
  let rect = element.getBoundingClientRect();

  return (
    rect.bottom > 0 &&
    rect.right > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
    rect.top < (window.innerHeight || document.documentElement.clientHeight)
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*
 * Custom Elements
 */
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = this.classList.contains('open');
    this.close = this.close.bind(this);

    document.body.addEventListener('keydown', (evt) => evt.code === 'Escape' && this.isOpen && this.close());

    this.querySelectorAll('.button-close-modal, .modal__backdrop').forEach((el) => {
      el.addEventListener('click', this.close);
    });
  }

  open() {
    this.isOpen = true;
    this.classList.add('open');

    let scrollBarWidth = window.innerWidth - document.documentElement.offsetWidth;

    document.body.style.paddingRight = scrollBarWidth + 'px';

    const openEvent = new CustomEvent('open', { detail: { panel: this } });
    this.dispatchEvent(openEvent);
    document.body.classList.add('modal-open');
  }

  close() {
    this.isOpen = false;
    this.classList.remove('open');

    document.body.style.removeProperty('padding-right');

    const closeEvent = new CustomEvent('close', { detail: { panel: this } });
    this.dispatchEvent(closeEvent);
    document.body.classList.remove('modal-open');
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[data-modal]');

    if (!button) {
      return;
    }

    button.addEventListener('click', (event) => {
      const modal = document.querySelector(button.getAttribute('data-modal'));

      if (modal) {
        event.preventDefault();
        modal.open();
      }
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  // removeErrorMessage() {
  //   const section = this.closest('section');
  //   if (!section) return;

  //   const productForm = section.querySelector('product-form');
  //   if (productForm) productForm.handleErrorMessage();
  // }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        input.removeAttribute('disabled');
      } else {
        input.classList.add('disabled');
        input.setAttribute('disabled', '');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function slideUp(target, duration = 500, easing = 'ease') {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.transitionTimingFunction = easing;
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;

  setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
    target.style.removeProperty('transition-timing-function');
  }, duration);
}

function slideDown(target, duration = 500, easing = 'ease') {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;

  if (display === 'none') display = 'block';

  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.transitionTimingFunction = easing;
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');

  setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
    target.style.removeProperty('transition-timing-function');
  }, duration);
}

function slideToggle(target, duration = 1000) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function getCookie(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
  return null;
}

function setCookie(name, value, exp) {
  let cValue = name + '=' + value + '; path=/';

  if (exp && exp > 0) {
    const expires = 'expires=' + new Date(Date.now() + exp).toUTCString();
    cValue += '; ' + expires;
  } else if (exp && exp < 0) {
    cValue += '; max-age=-1';
  }

  document.cookie = cValue;
}

// Collapsible component
class CollapsibleContent extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      container: this.querySelector('.accordion'),
      handle: this.querySelector('[data-action="toggle-collapse"]'),
      content: this.querySelector('.accordion__content'),
    };

    const style = window.getComputedStyle(this.elements.content);
    const duration = parseFloat(style.getPropertyValue('transition-duration')) * 1000;
    const timing = style.getPropertyPriority('transition-timing-function');

    this.options = {
      duration: duration ? duration : 500,
      timing: timing ? timing.toString() : 'ease',
    };

    this.isOpen = this.elements.container.classList.contains('active');

    this.bindEvents();
  }

  bindEvents() {
    if (this.elements.handle) {
      this.elements.handle.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  close() {
    this.isOpen = false;
    this.elements.container.classList.remove('active');
    this.elements.content.setAttribute('aria-hidden', 'true');
    this.elements.handle.setAttribute('aria-expanded', 'false');
    slideUp(this.elements.content, this.options.duration, this.options.timing);
  }

  open() {
    this.isOpen = true;
    this.elements.container.classList.add('active');
    this.elements.content.setAttribute('aria-hidden', 'false');
    this.elements.handle.setAttribute('aria-expanded', 'true');
    slideDown(this.elements.content, this.options.duration, this.options.timing);
  }
}

customElements.define('collapsible-content', CollapsibleContent);

class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-handle]');
    this.cart = document.querySelector('cart-drawer');
    this.quickView = document.querySelector('quick-view-modal');

    if (this.button) {
      this.button.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  onButtonClick(e) {
    e.preventDefault();

    if (this.hasAttribute('loading') || this.hasAttribute('disabled')) {
      return;
    }

    const itemId = this.button.dataset.itemId;

    if (itemId) {
      this.ajaxAddToCart();
    } else {
      this.openQuickView();
    }
  }

  ajaxAddToCart() {
    const config = fetchConfig('javascript');

    let formData = {
      items: [
        {
          id: parseInt(this.button.dataset.itemId),
          quantity: parseInt(this.button.dataset.quantity),
        },
      ],
    };

    if (this.cart) {
      formData['sections'] = this.cart.getSectionsToRender().map((section) => section.section);
      formData['sections_url'] = window.location.pathname;
    }

    config.body = JSON.stringify(formData);

    this.setButtonState('loading');

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-add',
          productVariantId: parseInt(this.button.dataset.itemId),
          cartData: response,
          errors: response.errors || response.description,
          message: response.message,
        });

        if (this.cart) {
          this.cart.renderContents(response);
        }

        this.setButtonState('added');

        setTimeout(() => this.setButtonState(''), 1000);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setButtonState('error');
      });
  }

  setButtonState(state) {
    switch (state) {
      case 'loading':
        this.setAttribute('loading', true);
        this.removeAttribute('added');
        this.removeAttribute('error');
        break;
      case 'added':
        this.setAttribute('added', true);
        this.removeAttribute('loading');
        this.removeAttribute('error');
        break;
      case 'error':
        this.setAttribute('error', true);
        this.removeAttribute('loading');
        this.removeAttribute('added');
        break;
      default:
        this.removeAttribute('loading');
        this.removeAttribute('added');
        this.removeAttribute('error');
        break;
    }
  }

  openQuickView() {
    if (!this.quickView) {
      return;
    }

    this.quickView.setAttribute('handle', this.button.dataset.handle);
    this.quickView.open();
  }
}

customElements.define('quick-add', QuickAdd);

/**
 * Só deve reordenar por disponibilidade quando a ordenação é "Em destaque" (manual).
 * Caso contrário mantém a ordem do servidor (preço, etc.).
 */
function shouldUseAvailabilitySort() {
  const params = new URLSearchParams(window.location.search);
  const sortBy = params.get('sort_by') || '';
  return !sortBy || sortBy === 'manual' || sortBy === 'manual-ascending' || sortBy === 'manual-descending';
}

/**
 * Ordena produtos por disponibilidade de variantes (replica lógica do Liquid)
 * Produtos com mais variantes disponíveis aparecem primeiro
 */
function sortProductsByAvailability(productItems) {
  if (!productItems || productItems.length === 0) return productItems;

  // Extrair informações de cada produto
  const productsData = Array.from(productItems).map((item, index) => {
    // Tentar encontrar o card de produto (pode estar no item ou dentro dele)
    const productCard = item.querySelector('.product-card') || item.querySelector('[data-product-handle]') || item;
    
    // Extrair handle do produto
    const handle = productCard.getAttribute('data-product-handle') || 
                   productCard.querySelector('a[href*="/products/"]')?.href?.match(/\/products\/([^\/\?]+)/)?.[1] || 
                   '';
    
    // Tentar encontrar informações de variantes do data-variant-info
    let sortScore = 100; // Default: menos disponível
    let availableVariants = 0;
    let totalVariants = 0;
    
    const variantInfoAttr = productCard.getAttribute('data-variant-info');
    if (variantInfoAttr) {
      try {
        const data = JSON.parse(variantInfoAttr);
        sortScore = data.sortScore !== undefined ? data.sortScore : 100;
        availableVariants = data.available || 0;
        totalVariants = data.total || 1;
      } catch (e) {
        console.warn('Erro ao parsear data-variant-info:', e);
      }
    } else {
      // Fallback: usar disponibilidade do produto
      const isAvailable = productCard.getAttribute('data-product-available') === 'true' ||
                         !productCard.classList.contains('unavailable') && 
                         !productCard.querySelector('.product-card__unavailable');
      availableVariants = isAvailable ? 1 : 0;
      totalVariants = 1;
      sortScore = isAvailable ? 0 : 100;
    }
    
    return {
      element: item,
      handle: handle,
      sortScore: sortScore,
      availableVariants: availableVariants,
      totalVariants: totalVariants,
      originalIndex: index
    };
  });

  // Ordenar por sortScore (menor score = mais disponível = aparece primeiro)
  productsData.sort((a, b) => {
    if (a.sortScore !== b.sortScore) {
      return a.sortScore - b.sortScore;
    }
    // Se empate, manter ordem original
    return a.originalIndex - b.originalIndex;
  });

  return productsData.map(p => p.element);
}

class LoadProducts extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.button');
    this.observer = null;

    if (this.hasAttribute('section')) {
      const section = document.getElementById('shopify-section-' + this.getAttribute('section'));

      this.list = section.querySelector('#' + this.getAttribute('selector'));
    }

    this.manualLoad = this.manualLoad.bind(this);
    this.autoLoad = this.autoLoad.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);

    // Se tiver botão, adicionar listener para clique manual
    if (this.button) {
      this.button.addEventListener('click', this.manualLoad);
    }

    // Se estiver em modo auto (infinite scroll), usar IntersectionObserver
    if (this.hasAttribute('auto')) {
      this.setupIntersectionObserver();
    }
  }

  connectedCallback() {
    // Em modo "Em destaque": pré-carrega 1–2 páginas a mais para ter uma única ordem por disponibilidade
    // (evita que o "final" da lista seja só o pior do primeiro lote de 50)
    if (!shouldUseAvailabilitySort() || !this.list || !this.button || !this.button.getAttribute('href')) return;
    const count = this.list.children.length;
    if (count < 50 || count > 100) return;
    const delay = count === 50 ? 900 : 400;
    if (this._preloadScheduled) return;
    this._preloadScheduled = true;
    setTimeout(() => {
      if (!this.list || this.getAttribute('loading')) return;
      this.loadProducts();
    }, delay);
  }

  setupIntersectionObserver() {
    // Usar sentinela invisível se existir, senão usar o próprio elemento
    const sentinel = document.querySelector('[data-infinite-scroll-sentinel]') || this;
    
    // Criar observer para detectar quando o sentinela entra na viewport
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.getAttribute('loading')) {
            this.loadProducts();
          }
        });
      },
      {
        rootMargin: '400px', // Começar a carregar 400px antes de chegar no sentinela
        threshold: 0.1
      }
    );

    this.observer.observe(sentinel);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  manualLoad(e) {
    if (e) {
      e.preventDefault();
    }

    if (this.getAttribute('loading')) {
      return;
    }

    this.loadProducts();
  }

  autoLoad(e) {
    if (!isInViewport(this.button || this)) {
      return;
    }

    if (this.getAttribute('loading')) {
      return;
    }

    this.loadProducts();
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.getAttribute('loading')) {
        this.loadProducts();
      }
    });
  }

  loadProducts() {
    const pageUrl = this.button.getAttribute('href');

    if (!pageUrl || this.hasAttribute('loading') || !this.list) {
      return;
    }

    const sep = pageUrl.indexOf('?') !== -1 ? '&' : '?';
    const url = pageUrl + sep + 'section_id=' + this.getAttribute('section');

    this.setAttribute('loading', true);

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        this.removeAttribute('loading');

        const html = new DOMParser().parseFromString(text, 'text/html');
        const grid = html.getElementById(this.getAttribute('selector'));

        if (!grid) {
          console.error('Grid not found in response');
          return;
        }

        // Coletar todos os novos produtos (servidor já envia na ordem correta quando há sort_by)
        const newItems = Array.from(grid.children);
        const itemsToAdd = shouldUseAvailabilitySort()
          ? sortProductsByAvailability(newItems)
          : newItems;

        let i = 0;
        for (let item of itemsToAdd) {
          const clonedItem = item.cloneNode(true);
          clonedItem.classList.add('animate--fade-in-up');
          clonedItem.style.animationDelay = i.toString() + '00ms';
          this.list.appendChild(clonedItem);
          i++;
        }

        if (shouldUseAvailabilitySort()) this.reorderAllProducts();

        const button = html.querySelector('load-products');
        const sentinel = html.querySelector('[data-infinite-scroll-sentinel]');
        const container = this.list.closest('.collection') || this.list.parentElement;

        if (button) {
          // Se estiver em modo auto, manter o observer funcionando
          if (this.hasAttribute('auto')) {
            // Remover sentinela antigo se existir
            const existingSentinel = document.querySelector('[data-infinite-scroll-sentinel]');
            if (existingSentinel) {
              existingSentinel.remove();
            }
            
            // Desconectar observer antigo
            if (this.observer) {
              this.observer.disconnect();
            }
            
            // Criar novo botão com as mesmas configurações
            const newButton = button.cloneNode(true);
            newButton.setAttribute('auto', 'true');
            newButton.setAttribute('section', this.getAttribute('section'));
            newButton.setAttribute('selector', this.getAttribute('selector'));
            
            // Adicionar sentinela após o grid (dentro do container da coleção)
            if (sentinel && container) {
              const newSentinel = sentinel.cloneNode(true);
              container.appendChild(newSentinel);
            }
            
            // Substituir elemento antigo pelo novo
            this.replaceWith(newButton);
          } else {
            this.replaceWith(button);
          }
        } else {
          // Não há mais páginas, remover observer e sentinela
          if (this.observer) {
            this.observer.disconnect();
          }
          const existingSentinel = document.querySelector('[data-infinite-scroll-sentinel]');
          if (existingSentinel) {
            existingSentinel.remove();
          }
          this.remove();
        }

        if (this.hasAttribute('update-history')) {
          window.history.pushState(null, '', pageUrl);
        }
      })
      .catch((e) => {
        console.error(e);
        this.removeAttribute('loading');
      });
  }

  /**
   * Reordena todos os produtos no grid por disponibilidade (só quando ordenação é "Em destaque")
   */
  reorderAllProducts() {
    if (!this.list || !shouldUseAvailabilitySort()) return;
    const allItems = Array.from(this.list.children);
    const sortedItems = sortProductsByAvailability(allItems);
    
    // Remover todos os itens
    allItems.forEach(item => item.remove());
    
    // Adicionar na ordem correta
    sortedItems.forEach((item, index) => {
      item.style.animationDelay = (index % 10).toString() + '00ms';
      this.list.appendChild(item);
    });
  }
}

customElements.define('load-products', LoadProducts);

class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('select');

    if (!this.input) {
      return;
    }

    this.isOpen = this.hasAttribute('open');
    this.trigger = this.querySelector('.custom-select__trigger');
    this.dropdown = this.querySelector('.custom-select__dropdown');
    this.options = this.querySelectorAll('.custom-select__option');

    this.onSelectOption = this.onSelectOption.bind(this);

    this.render();

    // Toggle dropdown.
    this.trigger.addEventListener('click', this.toggle.bind(this));

    // Close dropdown when clicking outside the component
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });

    // Close dropdown on ESC key press
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Select option.
    this.options.forEach((option) => option.addEventListener('click', this.onSelectOption));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.setAttribute('open', true);
  }

  close() {
    this.isOpen = false;
    this.removeAttribute('open');
  }

  onSelectOption(event) {
    event.preventDefault();

    const selectedOption = event.target.closest('li');
    const index = Array.from(this.dropdown.children).indexOf(selectedOption);
    const changeEvent = new Event('change', { bubbles: true });
    const inputEvent = new Event('input', { bubbles: true });

    if (
      selectedOption.getAttribute('aria-selected') === 'true' ||
      selectedOption.getAttribute('aria-disabled') === 'true'
    ) {
      this.close();
      return;
    }

    this.options.forEach((option) => option.setAttribute('aria-selected', false));
    selectedOption.setAttribute('aria-selected', true);

    this.trigger.querySelector('.custom-select__current').innerText = selectedOption.innerText;

    this.input.value = selectedOption.dataset.value;
    this.input.selectedIndex = index;
    this.input.dispatchEvent(changeEvent);
    this.input.dispatchEvent(inputEvent);

    this.close();
  }

  render() {
    const selected = this.input.options[this.input.selectedIndex];

    if (!this.trigger) {
      const trigger = document.createElement('button');
      trigger.setAttribute('type', 'button');
      trigger.setAttribute('value', selected.value);
      trigger.setAttribute(
        'class',
        'custom-select__trigger button button--icon button--plain' +
          (this.getAttribute('size') ? ' button--' + this.getAttribute('size') : '')
      );
      trigger.innerHTML = `<span class="custom-select__current">${selected.text}</span><span class="caret" aria-hidden="true"></span>`;

      this.appendChild(trigger);
      this.trigger = trigger;
    }

    if (!this.dropdown) {
      const options = Array.from(this.input.options);
      const template = `
        ${options
          .map(
            (option) => `
              <li
                role="button"
                class="custom-select__option${option.disabled ? ' disabled' : ''}"
                data-value="${option.value}"
                ${option.disabled ? 'aria-disabled="disabled"' : ''}
                aria-selected="${option.value === selected.value ? 'true' : 'false'}"
              >
                ${option.textContent}
              </li>
            `
          )
          .join('')}
      `;
      const dropdown = document.createElement('ul');
      dropdown.className = 'list-unstyled custom-select__dropdown';
      dropdown.innerHTML = template;

      this.appendChild(dropdown);
      this.dropdown = dropdown;
      this.options = dropdown.querySelectorAll('.custom-select__option');
    }
  }
}

// Define the custom element 'custom-select'
customElements.define('custom-select', CustomSelect);

class MarqueeContent extends HTMLElement {
  constructor() {
    super();
    this.marquee = null;
  }

  connectedCallback() {
    let observe;

    try {
      observe = new ResizeObserver((entries) => {
        debounce(this.toggle(), 200);
      });
    } catch (err) {
      observe = new IntersectionObserver((entries) => {
        debounce(this.toggle(), 200);
      });
    }

    observe.observe(document.body);
  }

  toggle() {
    this.setAttribute('loading', '');
    this.offsetWidth < this.scrollWidth ? this.setAttribute('on', '') : this.removeAttribute('on');
    this.removeAttribute('loading');
  }
}

customElements.define('marquee-content', MarqueeContent);

class RecentlyViewedProductsTracker {
  constructor() {
    this.storageKey = 'recently-viewed-products';
    this.maxProducts = 24; // Store more products but display fewer
    this.initialize();
  }

  initialize() {
    // Check if we're on a product page using meta tags
    const productMeta = document.querySelector('meta[property="og:type"]');
    if (productMeta && productMeta.content === 'product') {
      const urlMeta = document.querySelector('meta[property="og:url"]');
      if (urlMeta) {
        const url = new URL(urlMeta.content);
        const match = url.pathname.match(/\/products\/([a-zA-Z0-9-_]+)/);
        if (match && match[1]) {
          this.addProduct(match[1]);
        }
      }
    }

    // Track on quick view
    const quickView = document.querySelector('quick-view-modal');
    if (quickView) {
      quickView.addEventListener('open', () => {
        const productHandle = quickView.getAttribute('handle');

        if (!productHandle) {
          return;
        }

        this.addProduct(productHandle);
      });
    }
  }

  getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch (e) {
      console.error('Error parsing recently viewed products:', e);
      return [];
    }
  }

  addProduct(handle) {
    const products = this.getProducts();
    const now = new Date().getTime();

    // Remove existing entry of this product if it exists
    const filteredProducts = products.filter((item) => item.handle !== handle);

    // Add the product to the beginning with current timestamp
    filteredProducts.unshift({
      handle: handle,
      viewedAt: now,
    });

    // Keep only the maximum number of products
    const trimmedProducts = filteredProducts.slice(0, this.maxProducts);

    // Save back to localStorage
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(trimmedProducts));
    } catch (e) {
      console.error('Error saving recently viewed products:', e);
    }
  }

  getRecentProducts(options = {}) {
    const defaultOptions = {
      limit: 4,
      excludeHandle: null,
      sortBy: 'recent',
    };

    const finalOptions = { ...defaultOptions, ...options };
    const products = this.getProducts();

    return products
      .filter((item) => item.handle !== finalOptions.excludeHandle)
      .slice(0, finalOptions.limit)
      .map((item) => item.handle);
  }
}

window.recentlyViewedProducts = new RecentlyViewedProductsTracker();
